<template>
  <div v-rect-loading="loading" class="step-list">
    <TableList
      defaultExpandAll
      rowKey="_vid"
      :listData="listData"
      :tableColumns="tableColumns"
      :actionBtn="actionBtn"
      @create="handleCreate"
    >
      <template #stepIcon="{ row }">
        <i v-if="row._vType === STEP_TYPE.STEP" class="step-icon" :class="row.icon"></i>
      </template>
      <template #required="{ data, row }">
        <el-switch v-if="row._vType === STEP_TYPE.QUESTION" disabled :value="data"></el-switch>
      </template>
      <template #status="{ row, data }">
        <el-switch v-if="row._vType === STEP_TYPE.STEP" :value="data" @change="onEnabledChange($event, row)"></el-switch>
      </template>
    </TableList>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import _ from 'lodash'
import { ONBOARDING_QUESTION_TYPE } from '@/constant/common'
import TableList from '@/components/tableList/allowDragSortTable.vue'

const STEP_TYPE = {
  STEP: 'STEP',
  QUESTION: 'QUESTION'
}

export default {
  components: {
    TableList
  },
  data () {
    return {
      loading: false,
      STEP_TYPE,
      questionType: ONBOARDING_QUESTION_TYPE,
      listData: []
    }
  },
  computed: {
    previewLocale () {
      return this.$parent.activePreviewLocale
    },
    tableColumns () {
      const columns = [
        {
          label: this.$t('admin.company.onboarding.label.stepName'),
          dataKey: 'title',
          formatter: (data, row) => {
            return row[`title_${this.previewLocale}`]
          }
        },
        {
          label: this.$t('admin.company.onboarding.label.stepIcon'),
          dataKey: 'icon',
          slotName: 'stepIcon'
        },
        {
          label: this.$t('admin.company.onboarding.label.stepStatus'),
          dataKey: 'status',
          slotName: 'status',
          formatter: (data, row) => {
            if (row._vType === STEP_TYPE.STEP) {
              return data
            }
          }
        },
        {
          label: this.$t('admin.company.onboarding.label.questionName'),
          dataKey: 'content',
          formatter: (data, row) => {
            return row[`content_${this.previewLocale}`]
          }
        },
        {
          label: this.$t('admin.company.onboarding.label.questionType'),
          dataKey: 'type',
          formatter: (data) => {
            if (data) {
              const i18nKey = this.questionType[data].i18nKey
              return this.$t(i18nKey)
            }
          }
        },
        {
          label: this.$t('admin.company.onboarding.label.isRequiredQuestion'),
          dataKey: 'is_required',
          slotName: 'required'
        }
      ]
      return columns
    },
    actionBtn () {
      return {
        edit: {
          show: (rowData) => rowData._vType === STEP_TYPE.STEP,
          onclick: this.handleEdit
        }
      }
    }
  },
  created () {
    this.fetchListData()
  },
  methods: {
    ...mapActions('onboardingManagement', ['searchStep', 'updateStep']),
    async fetchListData () {
      this.loading = true
      try {
        const resp = await this.searchStep()
        const stepType = STEP_TYPE.STEP
        const questionType = STEP_TYPE.QUESTION
        if (resp && resp.steps) {
          this.listData = _.map(resp.steps, item => {
            const dataItem = {
              ...item,
              _vid: `${stepType}_${item.id}`,
              _vType: stepType,
              children: [],
              status: item.status === 1
            }
            if (dataItem.questions && dataItem.questions.length > 0) {
              dataItem.children = _.map(dataItem.questions, question => {
                return {
                  ...question,
                  _vid: `${stepType}_${item.id}_${questionType}_${question.id}`,
                  _vType: questionType
                }
              })
            }
            delete dataItem.questions
            return dataItem
          })
        }
      } finally {
        this.loading = false
      }
    },
    handleCreate () {
      this.$router.push({ name: 'addOnboardingStep' })
    },
    handleEdit (rowData) {
      this.$router.push(`/v-admin/onboarding-management/step/edit/${rowData.id}`)
    },
    async onEnabledChange (status, rowData) {
      this.loading = true
      try {
        const statusData = {
          id: rowData.id,
          change_status: status
        }
        const resp = await this.updateStep(statusData)
        if (resp) {
          rowData.status = statusData.change_status
          this.$message.success(this.$t('common.message.optionSuccess'))
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.step-list {
  .step-icon {
    font-size: 32px;
  }

  .status-icon {
    background: url($baseDomain + 'static/images_en/img_grey.png') no-repeat;
    width: 15px;
    height: 15px;
    display: inline-block;

    &.is-active {
      background: url($baseDomain + 'static/images_en/img_green.png') no-repeat;
    }
  }
}
</style>
